import { z } from "zod";

export const emailSchema = z
    .string()
    .min(1, "Email is required")
    .email("Please enter a valid email address");

export const phoneSchema = z
    .string()
    .min(1, "Phone number is required")
    .refine((val) => {
        const digits = val.replace(/\D/g, "");
        return digits.length >= 10;
    }, "Please enter a valid phone number (at least 10 digits)");

export const nameSchema = z
    .string()
    .min(1, "Name is required")
    .min(2, "Name must be at least 2 characters");

export const companySchema = z
    .string()
    .min(1, "Company/Brand name is required");

export const urlSchema = z
    .string()
    .min(1, "Domain is required")
    .regex(
        /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
        "Please enter a valid domain (e.g., example.com)"
    );
